export default {
	init() {
		const urlParams = new URLSearchParams(window.location.search);
		const email = urlParams.get('email');
		if (!email) return;

		const fieldsToMap = {
			email: 'EmailAddress',
			firstname: 'FirstName',
		};

		const maxAttempts = 50;
		let attempts = 0;

		const interval = setInterval(() => {
			attempts++;

			const emailField = document.querySelector('.ngp-form input[name="EmailAddress"]');

			if (emailField) {
				clearInterval(interval);

				for (const [param, fieldName] of Object.entries(fieldsToMap)) {
					const value = urlParams.get(param);
					if (!value) continue;

					const field = document.querySelector(`.ngp-form input[name="${fieldName}"]`);
					if (!field) continue;

					field.value = value;
					field.dispatchEvent(new Event('input', { bubbles: true }));
					field.dispatchEvent(new Event('change', { bubbles: true }));
				}
			} else if (attempts >= maxAttempts) {
				clearInterval(interval);
			}
		}, 100);
	},
};
